import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-red-600 py-2.5 px-4 text-center" data-id="element-1">
      <p className="text-white font-bold text-xs sm:text-sm uppercase tracking-wide animate-pulse" data-id="element-2">
        ⚠️ ÚLTIMA OPORTUNIDAD: ESTA VERSIÓN REBAJADA NO VOLVERÁ A APARECER
      </p>
    </div>;
}